import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Spin } from 'antd';
import { RETARD_MILISEGONS_APARICIO_SPINNER } from '../../constants';

import UsuariFormulari from './usuariFormulari';
import errorBoundaryWrapper from '../commons/errorBoundaryWrapper';

import {
    usuariIntroduccioDescartarCanvis,
    usuariIntroduccioEnviarFormulari
} from '../../actions/usuari';

import { 
    selectorFormulariIdUsuariSeleccionat,
    selectorPeticioInserirEnCurs
} from '../../selectors/selector_usuari';

import { rutaUsuaris, rutaDetallUsuaris } from '../../routes/routeConstants';

class UsuariIntroduccio extends Component {

    generarBotoCancelar() {

        const { idUsuari, peticioEnviarFormulariEnCurs, usuariIntroduccioDescartarCanvis } = this.props;

        const ruta = (idUsuari === null) ? rutaUsuaris : rutaDetallUsuaris;
        const onClick = (idUsuari === null) ? () => {} : usuariIntroduccioDescartarCanvis;

        return (
            <Link to={ruta}>
                <Button size='large' disabled={peticioEnviarFormulariEnCurs} onClick={onClick}>
                    Cancel·lar
                </Button>
            </Link>
        );
    }

    render() {

        const { router, peticioEnviarFormulariEnCurs, usuariIntroduccioEnviarFormulari } = this.props;

        const botoCancelar = this.generarBotoCancelar();

        return (
            <Spin spinning={peticioEnviarFormulariEnCurs} delay={RETARD_MILISEGONS_APARICIO_SPINNER}>
                <div className='usuari-introduccio-i-detall'>
                    <div className='usuari-introduccio-i-detall-contenidor'>
                        <UsuariFormulari esEditable={true} />
                    </div>
                    <div className='usuari-introduccio-i-detall-botons'>
                        <Button 
                            type='primary' 
                            size='large' 
                            disabled={peticioEnviarFormulariEnCurs}
                            onClick={() => usuariIntroduccioEnviarFormulari(router)}>
                            Guardar
                        </Button>
                        {botoCancelar}
                    </div>
                </div>
            </Spin>
        );
    }
}

UsuariIntroduccio.propTypes = {
    idUsuari: PropTypes.number,
    peticioEnviarFormulariEnCurs: PropTypes.bool,
    usuariIntroduccioDescartarCanvis: PropTypes.func,
    usuariIntroduccioEnviarFormulari: PropTypes.func,
    router: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        idUsuari: selectorFormulariIdUsuariSeleccionat(state),
        peticioEnviarFormulariEnCurs: selectorPeticioInserirEnCurs(state)
    };
};

const mapDispatchToProps = {
    usuariIntroduccioDescartarCanvis,
    usuariIntroduccioEnviarFormulari
};

export default errorBoundaryWrapper(connect(mapStateToProps, mapDispatchToProps)(UsuariIntroduccio));



// WEBPACK FOOTER //
// ./src/components/usuari/usuariIntroduccio.js